import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { GroupService } from '@services/groups/group.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { FormComponent } from '../../../components/default-form/form.component';

@Component({
    selector: 'app-group-edit',
    templateUrl: './group-edit.component.html',
    styleUrls: ['./group-edit.component.scss'],
    providers: [GroupService],
    standalone: false
})
export class GroupEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  pageActions: PageAction[];
  title = 'Create Group';
  isLoading = true;
  boundGroup: Models.Group;
  groupId: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private groupService: GroupService,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.title = 'Edit Group';
      this.createPageActions();
      this.groupId = this.activatedRoute.snapshot.params['id'];
      this.groupService.get(this.activatedRoute.snapshot.params['id']).then(result => {
        this.boundGroup = result;
        this.isLoading = false;
        this.loadForm();
      });
    } else {
      this.boundGroup = <Models.Group>Models.ModelFactory.createModelInstanceByName('Group');
      this.isLoading = false;
      this.loadForm();
    }
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundGroup;
  }

  onSave() {
    return this.boundGroup.validate(true).then(result => {
      if (result.success) {
        if (this.groupId) {
          this.groupService.update(this.groupId, this.boundGroup).then(groupResult => {
            console.log(groupResult);
          });
        } else {
          this.groupService.create(this.boundGroup).then(groupResult => {
            console.log(groupResult);
          });
        }
      } else {
        this.snackbar.open('Could not create the group, please fill in the form correctly');
      }
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Detail',
        callback: () => {
          this.router.navigate(['groups', this.activatedRoute.snapshot.params['id']]);
        }
      })
    ]
  }

}
